var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "border-2 border-gray-600 border-opacity-25 border-dashed rounded-2xl mx-5 md:mx-10 xl:mx-32 p-5 xl:p-10 w-full"
  }, [_c('p', {
    staticClass: "text-base text-center uppercase mb-5"
  }, [_vm._v("\n    Clôturer l'évaluation en date du\n    "), _c('span', {
    staticClass: "text-pink-600"
  }, [_vm._v(_vm._s(_vm.today))])]), _vm._v(" "), _c('div', {
    staticClass: "flex flex-wrap flex-col md:flex-row justify-center items-center space-x-0 gap-y-3 md:space-x-3 md:space-y-0 md:max-w-full"
  }, [_c('action-button', {
    attrs: {
      "border-color": "border-transparent",
      "text-color": "text-white",
      "bg-color": "bg-indigo-600",
      "bg-color-square": "bg-indigo-600",
      "icon-color": "text-white",
      "libelle": "Clôturer l'évaluation",
      "uppercase": true,
      "icon": "save"
    },
    on: {
      "clickAction": function ($event) {
        return _vm.$emit('confirmCloseEvaluation');
      }
    }
  }), _vm._v(" "), !_vm.$isMobile() && _vm.canCompareCartography ? _c('action-button', {
    attrs: {
      "border-color": "border-indigo-600",
      "text-color": "text-indigo-600",
      "bg-color": "bg-white",
      "bg-color-square": "bg-white",
      "icon-color": "text-pink-600",
      "libelle": "Comparer les cartographies",
      "uppercase": true,
      "icon": "bar-chart-2"
    },
    on: {
      "clickAction": function ($event) {
        return _vm.$emit('displayCompareCarto');
      }
    }
  }) : _vm._e(), _vm._v(" "), !_vm.$isMobile() && _vm.canCompareButNotEnoughEvaluation ? _c('action-button', {
    attrs: {
      "border-color": "border-indigo-600",
      "text-color": "text-indigo-600",
      "bg-color": "bg-white",
      "bg-color-square": "bg-white",
      "icon-color": "text-pink-600",
      "libelle": "Comparer les cartographies",
      "icon": "bar-chart-2",
      "uppercase": true,
      "is-disabled": true,
      "disabled-tooltip": "Pour profiter de cette fonctionnalité, veuillez faire une deuxième évaluation pour les comparer."
    }
  }) : _vm._e()], 1), _vm._v(" "), _vm.currentEval ? _c('p', {
    staticClass: "text-base text-center mt-5 text-gray-700"
  }, [_vm._v("\n    Dernière modification apportées le\n    " + _vm._s(new Date(_vm.currentEval.updated_at).toLocaleDateString(undefined, {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  })) + "\n    à\n    " + _vm._s(new Date(_vm.currentEval.updated_at).toLocaleTimeString()) + "\n  ")]) : _vm._e()]);

}
var staticRenderFns = []

export { render, staticRenderFns }